@if (ticket.isSourceDeprecated) {
    <div class="alert alert-info">
        <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
        </sb-inline-svg>
        <span>
            {{ 'You cannot reply to or edit this ticket because its source is deprecated.' | translate }}
        </span>
    </div>
} @else {
    @if (isNeedToAnswerByPermalink) {
        <div class="alert alert-info">
            <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
            </sb-inline-svg
            >&nbsp; {{ ticket.source | ticketSource }}&nbsp;
            {{ 'has some limitations, so this ticket needs to be answered on' | translate }}&nbsp;
            {{ ticket.source | ticketSource }}{{ '. Click' | translate }}
            <a [href]="ticket.permalink" target="_blank" translate>here to reply</a>
        </div>
    }

    @if (isPostHiddenAlert) {
        <div class="alert alert-info">
            <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
            </sb-inline-svg
            >&nbsp;
            {{ 'This post is hidden from your page.' | translate }}
        </div>
    }

    @if (isNoSocialMediaSourceInstalledAlert) {
        <div class="alert alert-info">
            <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
            </sb-inline-svg>
            <span>
                {{
                    'You can not reply to, or edit this ticket. There is no social media account installed associated with this ticket anymore. Click'
                        | translate
                }}
            </span>
            <a (click)="openInstallationPage(this.ticket.source)" translate>here</a>
            <span translate> to add a Social media account.</span>
        </div>
    }
    @if (isTicketClosedOrMovedToSpamAlert) {
        <div class="alert alert-info">
            <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
            </sb-inline-svg>
            @if (ticket.constraints.isTicketStatusImmutableAndConnectedToChatEnd) {
                <span
                    >&nbsp;{{
                        "The ticket is closed. You can't reply on this ticket or change its status." | translate
                    }}</span
                >
            } @else {
                &nbsp;{{ "The ticket is closed or moved to spam. You can't reply on this ticket. Click" | translate }}
                @if (!ticket.isAssignedToBot) {
                    <a (click)="restore()" class="pointer" translate>here</a>
                }
                {{ 'to open this ticket again.' | translate }}
            }
        </div>
    }

    @if (isNeedToAddUserInfo) {
        <div class="alert alert-info">
            <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
            </sb-inline-svg>
            &nbsp;{{ "You cannot reply to this ticket until you add the user's email address. Click" | translate }}
            @if (!commonDataService.isOneTime) {
                <a (click)="openEditUserForm()" class="pointer" translate>here</a>
            }
            {{ 'to edit user info.' | translate }}
        </div>
    }

    @if (isAssignedToAnotherUserAlert) {
        <div class="alert alert-info">
            <sb-inline-svg
                class="icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Lockd icon.svg'"></sb-inline-svg
            >&nbsp; <span translate>This ticket is assigned to</span>&nbsp;<a
                (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: ticket.assignee })"
                >{{ ticket.assignee.name || ticket.assignee.email }}</a
            >, <span translate>and can only be viewed.</span>
        </div>
    }

    @if (isTicketAssigningObligatoryAlert) {
        <div class="alert alert-info">
            <sb-inline-svg
                class="icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Lockd icon.svg'"></sb-inline-svg
            >&nbsp; <span>{{ 'To handle this ticket, please' | translate }} </span>
            @if (!commonDataService.isOneTime) {
                <a
                    translate
                    (click)="
                        assignService.isAssigningTicket || assignTicket({ event: $event, data: { isAssigned: true } })
                    "
                    >assign</a
                >
            }
            @if (commonDataService.isOneTime) {
                <span translate>assign</span>&nbsp;<span translate>it first.</span>
            }
        </div>
    }

    @if (isCustomerLeftChatAlert) {
        <div class="alert alert-info">
            @if (isReplyAddingBlockedWhenChatIsEndedAlert) {
                <sb-inline-svg
                    class="icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
                </sb-inline-svg
                >&nbsp;{{ 'Live chat is unavailable. You can no longer reply to this ticket.' | translate }}
            } @else {
                <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Mail icon.svg'">
                </sb-inline-svg
                >&nbsp;{{ 'Live chat is unavailable. Your reply will be sent by email.' | translate }}
            }
        </div>
    }

    @if (isTakeOverAlert) {
        <div class="alert alert-info">
            <sb-inline-svg
                class="icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Bot icon.svg'"></sb-inline-svg
            >&nbsp;{{ 'This ticket is in BOT mode.' | translate }}
            <button class="btn btn-sm ms-2" (click)="takeOverTicket()" translate>Take over</button>
        </div>
    }

    @if (ticket.reminder) {
        <div class="alert alert-info">
            <sb-inline-svg
                class="icon"
                style="padding: 0 0 3px 0"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Timer outlined icon.svg'">
            </sb-inline-svg
            >&nbsp;{{
                ('The reminder ends at' | translate) +
                    (ticket.reminder.time | date: ' dd.MM.yyyy HH:mm ') +
                    (ticket.reminder.isSetTicketStatusToOpenAfterRemind
                        ? ('with' | translate)
                        : ('without' | translate)) +
                    ' ' +
                    ('setting "Open" status. Click' | translate)
            }}
            <a class="pointer" (click)="deleteReminder()" translate>here</a>
            {{ 'to remove the reminder.' | translate }}
        </div>
    }
}
